import type { Address } from "viem";
import { getFactory } from "./config-loader";

// Example: create a factory for sandbox (should be done at app init)
// export const factoryPromise = getTurnstileFactory('sandbox');
// Usage: const factory = await factoryPromise;

// Getter functions - config must be initialized first
export const getL1AllowListAddr = () => getFactory().getDeploymentData().l1AllowList as Address;
export const getL1PortalAddr = () => getFactory().getDeploymentData().l1Portal as Address;
export const getL2PortalAddr = () => getFactory().getDeploymentData().aztecPortal;
export const getAztecShieldGatewayAddr = () => getFactory().getDeploymentData().aztecShieldGateway;
export const getAztecTokenContractClassID = () => getFactory().getDeploymentData().aztecTokenContractClassID as Address;
export const getTokens = () => getFactory().getDeploymentData().tokens;

console.log("Addresses module loaded");
